import axios from "axios";
import { Plus, WalletCards } from "lucide-react";
import { useEffect, useState } from "react";

export const WalletHeader = ({
  activeWallet,
  setActiveWallet,
  userRole,
  setShowAddMoneyModal,
}) => {
  const [currentUserRole, setCurrentUserRole] = useState(null);
  const [mobNumber, setMobNumber] = useState("");
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [email, setEmail] = useState("");

  const checkSpecialagent = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/special-agent/check-special-agent-child`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    const responseData = response.data?.agentData?.supportInfo[0];
    if (responseData) {
      setMobNumber(responseData.mob);
      setWhatsappNumber(responseData.whatsappNo);
      setEmail(responseData.email);
    }
  };
  useEffect(() => {
    checkSpecialagent();
  }, []);
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    setCurrentUserRole(user.role);
  });
  const canShowWallet = (walletType) => {
    switch (userRole) {
      case "admin":
        return true;
      case "agent":
        return walletType === "my" || walletType === "subagents";
      case "subagent":
        return walletType === "my";
      default:
        return false;
    }
  };

  const renderWalletButton = (walletType, label) => {
    if (!canShowWallet(walletType)) return null;

    const isActive = activeWallet === walletType;
    const showIcon = userRole === walletType.replace("s", ""); // 'agents' -> 'agent'

    return (
      <button
        onClick={() => setActiveWallet(walletType)}
        className={`flex items-center space-x-2 px-3 py-2 rounded ${
          isActive ? "bg-indigo-100 text-indigo-700" : "hover:bg-gray-100"
        }`}
      >
        {showIcon && <WalletCards className="h-6 w-6 text-indigo-600" />}
        <span className={showIcon ? "text-lg font-bold" : ""}>{label}</span>
      </button>
    );
  };
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(
      "Hello, Please add funds in my Wallet for RC."
    );
    window.open(
      `https://wa.me/${
        whatsappNumber ? whatsappNumber : "919124578108"
      }?text=${message}`,
      "_blank"
    );
  };
  return (
    <header className="bg-white shadow-sm">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <div className="flex flex-wrap items-center space-x-4">
          {renderWalletButton("my", "My Wallet")}
          {renderWalletButton("agents", "Agents Wallet")}
          {renderWalletButton("subagents", "Subagents Wallet")}
        </div>
        {/* {currentUserRole !== "sub-agent" && ( */}
          <button
            onClick={handleWhatsAppClick}
            className="flex items-center space-x-2 bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition"
          >
            <Plus className="h-4 w-4" />
            <span>Add Money</span>
          </button>
        {/* )} */}
        {/* {currentUserRole === "sub-agent" && (
          <button
            onClick={() => setShowAddMoneyModal(true)}
            className="flex items-center space-x-2 bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition"
          >
            <Plus className="h-4 w-4" />
            <span>Add Money</span>
          </button>
        )} */}
      </div>
    </header>
  );
};
